import React from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../../generic/CustomBtn/CustomBtn';
import { ReactComponent as AttentionIcon } from '../../../../../../assets/image/carbon/triangle-exclamation.svg';
import './LeavePopup.scss';

const LeavePopup = ({ handleLeave = () => {}, handleSubmit = () => {}, handleClose = () => {} }) => {
  const translate = useIntl();
  return (
    <div className="leave-popup__wrapper">
      <div className="leave-popup">
        <div className="leave-popup__close-button-wrapper">
          <CustomBtn
            handleClick={() => handleClose()}
            customClass="leave-popup__close-button"
            iconClass="icon-close"
          />
        </div>
        <div className="leave-popup__image">
          <AttentionIcon />
        </div>
        <h3 className="leave-popup__title">{translate.formatMessage({ id: 'carbon.leavePopup.leavePage' })}</h3>
        <p className="leave-popup__subtitle">{translate.formatMessage({ id: 'carbon.leavePopup.changesMayNotBeSaved' })}</p>
        <div className="leave-popup__buttons">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-leave' })}
            handleClick={() => handleLeave()}
            customClass="leave-popup__leave-button"
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-save' })}
            handleClick={() => handleSubmit()}
            customClass="leave-popup__save-button"
          />
        </div>
      </div>
    </div>
  );
};

export default LeavePopup;
